import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Component, Input, NgZone, OnDestroy, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { of, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, take, filter, pairwise, throttleTime } from 'rxjs/operators';
import { DataStorageService } from '../shared/servizi/data-storage.service';
import cytoscape from 'cytoscape';
import cola from 'cytoscape-cola';
cytoscape.use(cola);
@Component({
  selector: 'app-pannello-filtro-multiplo',
  templateUrl: './pannello-filtro-multiplo.component.html',
  styleUrls: ['./pannello-filtro-multiplo.component.css', '../mediaquerie.css']
})
export class PannelloFiltroMultiploComponent implements OnInit, OnDestroy {
  _clicked: Subject<boolean> = new Subject();
  _minPathClicked: Subject<boolean> = new Subject();
  _inferenzeRecuperate: Subject<boolean> = new Subject();
  _concettiRecuperati: Subject<boolean> = new Subject();
  @Input()
  set events(val: Subject<boolean>) {
    this._clicked = val;
  }

  private eventsSubscription: Subscription;

  private eventsSubscriptionInferenzeRecuperate: Subscription;

  private eventsSubscriptionConcettiRecuperati: Subscription;

  // recupero inferenze
  @Input()
  set recuperoInferenze(val: Subject<boolean>) {
    this._inferenzeRecuperate = val;
  }

  // recupero concetti
  @Input()
  set recuperoConcetti(val: Subject<boolean>) {
    this._concettiRecuperati = val;
  }

  sub: Subscription;
  @Input() cy: any;
  @Output() emettoView = new EventEmitter<any>();

  nodiSelezionati: any[] = [];
  // array per salvare nodi salvati con chiamata a servizio node path
  nodiExtra: any[] = [];
  // array per salvare edge che non contengono senseRel
  arrayNoSenseRel: any = [];

  singoliPercorsi: any = [];
  cercaSensi: FormGroup;
  // colonna sinistra filtro e virtual scroll
  searchText = '';
  searchMode = "startsWith";
  type = "word";
  field = "";
  pos = "";
  formType = "entry";
  author = "";
  lang = "it";
  status = "";
  offset = 0;
  limit = 200;
  totalCount;
  sensi: any[];
  sensiVisibili: any[];
  senso1;
  senso2;

  // inferenze
  inferenze: boolean;
  arrayInferiti: any[] = [];
  arrayNonInferiti: any[] = [];

  // concetti
  arrayConcetti: any[] = [];
  arrayConcettiSI: any[] = [];
  arrayConcettiNO: any[] = [];
  concetti: boolean;
  constructor(
    private dataStorageService: DataStorageService,
    private ngZone: NgZone,
  ) { }

  @ViewChild(CdkVirtualScrollViewport) scroller: CdkVirtualScrollViewport;

  ngOnInit(): void {
    if (sessionStorage.getItem('nodiSelezionati')) {
      this.nodiSelezionati = JSON.parse(sessionStorage.getItem('nodiSelezionati'));
      var elementiVisibili = this.cy.elements(':visible');
      this.cy.fit(elementiVisibili);
    }
    this.cercaSensi = new FormGroup({
      cercaSensi: new FormControl()
    });
    this.eventsSubscription = this._clicked.subscribe((x) => {
      if (x === false) {
        this.nodiSelezionati.length = 0;
        this.cercaSensi.setValue({ cercaSensi: '' });
      }
    });

    // subscription per recuperare o meno inferenze
    this.eventsSubscriptionInferenzeRecuperate = this._inferenzeRecuperate.subscribe((x) => {
      this.inferenze = x;
      let source = sessionStorage.getItem('senso1');
      let target = sessionStorage.getItem('senso2');
      this.cy.getElementById(source).addClass('sourceMinPath');
      this.cy.getElementById(target).addClass('targetMinPath');
      // chiamo servizio recupero min path
      this.dataStorageService.fetchMinPath(source, target, this.inferenze).subscribe(el => {
        // // elimino nodi concetti inclusi
        this.arrayConcetti.forEach(ele => {
          ele.nodes.forEach(nodi => {
            let eleConcettiSIDaRimuovere = this.cy.getElementById(nodi.data.id);
            this.cy.remove(eleConcettiSIDaRimuovere)
          })
        });

        // elimino nodi inferiti se slide è su visualizza nodi NON inferiti
        this.arrayInferiti.forEach(ele => {
          ele.nodes.forEach(nodi => {
            let eleInferitiDaRimuovere = this.cy.getElementById(nodi.data.id);
            this.cy.remove(eleInferitiDaRimuovere)
          })
        })
        // elimino nodi non inferiti se slide è su visualizza nodi inferiti
        this.arrayNonInferiti.forEach(ele => {
          ele.nodes.forEach(nodi => {
            let eleNonInferitiDaRimuovere = this.cy.getElementById(nodi.data.id);
            this.cy.remove(eleNonInferitiDaRimuovere)
          })
        })
        // svuoto array 
        this.arrayNoSenseRel = [];
        this.arrayInferiti = [];
        this.arrayNonInferiti = [];
        this.arrayConcettiSI = [];
        this.arrayConcettiNO = [];
        this.arrayConcetti = [];
        for (var i = 0; i < el.length; i++) {
          for (var j = 0; j < el[i].nodes.length; j++) {
            if (el[i].nodes[j].data.id !== source && el[i].nodes[j].data.id !== target) {
              // aggiungo nell'array nodi extra i nodi caricati con il servizio min node path
              this.nodiExtra.push(el[i].nodes[j].data.id)
            }
          }
        }

        el.forEach(percorso => {
          let accettable = true;
          percorso.edges.forEach(edge => {
            if (
              edge.data.relationType === "http://www.w3.org/ns/lemon/ontolex#reference" ||
              edge.data.relationType === "http://www.w3.org/ns/lemon/ontolex#isReferenceOf" ||
              edge.data.relationType === "http://www.w3.org/ns/lemon/vartrans#senseRel" ||
              edge.data.relationType === "http://www.lexinfo.net/ontology/3.0/lexinfo#meronymTerm" ||
              edge.data.relationType === "http://www.lexinfo.net/ontology/3.0/lexinfo#holonymTerm" ||
              edge.data.relationType === "http://www.lexinfo.net/ontology/3.0/lexinfo#partitiveRelation") {
              accettable = false;
            }
          });
          if (accettable) {
            this.arrayNoSenseRel.push(percorso);
          }
        });
        this.arrayNoSenseRel.forEach(elemento => {
          if (this.inferenze === true) {
            this.arrayInferiti.push(elemento)
          } else {
            this.arrayNonInferiti.push(elemento)
          }
          let nodi = elemento.nodes;
          let edge = elemento.edges;
          for (var i = 0; i < nodi.length; i++) {
            this.cy.add([{
              group: "nodes",
              data: {
                id: nodi[i].data.id,
                label: nodi[i].data.label
              }
            }]);
            this.cy.getElementById(nodi[i].data.id).style('display', 'element');
            this.cy.getElementById(nodi[i].data.id).addClass('label');
            this.cy.getElementById(nodi[i].data.id).addClass('grigio');
            // mantengo colore bordo assegnati a source e target
            this.cy.getElementById(source).addClass('sourceMinPath');
            this.cy.getElementById(target).addClass('targetMinPath');
          }
          // creo edge collegati
          for (var i = 0; i < edge.length; i++) {
            // splitto stringa del relationType per stampare solo nome relazione e non tutto il link
            var relation = edge.map(el => {
              let nuovo = el.data.relationType.split('#')[1]
              return nuovo
            })
            this.cy.add([{
              group: "edges",
              data: {
                id: edge[i].data.id,
                source: edge[i].data.source,
                target: edge[i].data.target,
                label: relation[i],
                inferred: edge[i].data.inferred,
                relationType: edge[i].data.relationType
              }
            }]);
            this.cy.getElementById(edge[i].data.id).style('display', 'element');
            this.cy.getElementById(edge[i].data.id).addClass('label');
            this.cy.getElementById(edge[i].data.id).style("edge-text-rotation", "autorotate");
            // stile per elementi inferiti
            if (edge[i].data.inferred === true) {
              this.cy.getElementById(edge[i].data.id).addClass('inferred')
            } else {
              this.cy.getElementById(edge[i].data.id).addClass('grigio');
            }
          }
        })
        var layout = this.cy.elements().filter(':visible').layout({
          name: 'cola',
          // convergenceThreshold: 100, // end layout sooner, may be a bit lower quality
          animate: false,
          edgeLength: 250,
          fit: true
        });
        layout.run();
        var elementiVisibili = this.cy.elements(':visible');
        this.cy.center(elementiVisibili);
        // let singoliPercorsi = [];
        for (var i = 0; i < this.arrayNoSenseRel.length; i++) {
          for (var j = 0; j < this.arrayNoSenseRel[0].edges.length; j++) {
            let primoPercorso = this.arrayNoSenseRel[0].edges[j];
            this.cy.getElementById(primoPercorso.data.id).removeClass('inferred');
            this.cy.getElementById(primoPercorso.data.id).removeClass('grigio');
            this.cy.getElementById(primoPercorso.data.id).addClass('percorsoSelected');
            if (primoPercorso.data.inferred === true) {
              this.cy.getElementById(primoPercorso.data.id).removeClass('inferred');
              this.cy.getElementById(primoPercorso.data.id).addClass('inferredPercorsoSelected');
            }
            // salvo singoli percorsi nell'array singoli percorsi
            this.singoliPercorsi.push(this.arrayNoSenseRel[i].edges);
          }
        }

      })
    });

    // subscription per recuperare o meno concetti
    this.eventsSubscriptionConcettiRecuperati = this._concettiRecuperati.subscribe((x) => {
      this.concetti = x;
      let source = sessionStorage.getItem('senso1');
      let target = sessionStorage.getItem('senso2');
      this.cy.getElementById(source).addClass('sourceMinPath');
      this.cy.getElementById(target).addClass('targetMinPath');
      if (this.concetti === true) {
        // chiamo servizio recupero min path
        this.dataStorageService.fetchMinPath(source, target, this.inferenze).subscribe(el => {
          if(el.length === this.arrayNoSenseRel.length){
            this.arrayNoSenseRel.forEach(ele =>{
              ele.edges.forEach(edge=>{
                this.cy.getElementById(edge.data.id).removeClass('inferred')
              })
            })
          } else {
            
          this.arrayConcetti = [];
          el.forEach(percorso => {
            let accettable = true;
            percorso.edges.forEach(edge => {
              if (
                edge.data.relationType === "http://www.w3.org/ns/lemon/vartrans#senseRel" ||
                edge.data.relationType === "http://www.lexinfo.net/ontology/3.0/lexinfo#meronymTerm" ||
                edge.data.relationType === "http://www.lexinfo.net/ontology/3.0/lexinfo#holonymTerm" ||
                edge.data.relationType === "http://www.lexinfo.net/ontology/3.0/lexinfo#partitiveRelation") {
                accettable = false;
              }
            });
            if (accettable) {
              this.arrayConcetti.push(percorso);
            }
          });
          this.arrayConcetti.forEach(elemento => {
            let nodi = elemento.nodes;
            let edge = elemento.edges;
            for (var i = 0; i < nodi.length; i++) {
              this.cy.add([{
                group: "nodes",
                data: {
                  id: nodi[i].data.id,
                  label: nodi[i].data.label
                }
              }]);
              this.cy.getElementById(nodi[i].data.id).style('opacity', '1');
              this.cy.getElementById(nodi[i].data.id).addClass('label');
              this.cy.getElementById(nodi[i].data.id).addClass('grigio');
              // mantengo colore bordo assegnati a source e target
              this.cy.getElementById(source).addClass('sourceMinPath');
              this.cy.getElementById(target).addClass('targetMinPath');
            }
            // creo edge collegati
            for (var i = 0; i < edge.length; i++) {
              // splitto stringa del relationType per stampare solo nome relazione e non tutto il link
              var relation = edge.map(el => {
                let nuovo = el.data.relationType.split('#')[1]
                return nuovo
              })
              this.cy.add([{
                group: "edges",
                data: {
                  id: edge[i].data.id,
                  source: edge[i].data.source,
                  target: edge[i].data.target,
                  label: relation[i],
                  inferred: edge[i].data.inferred,
                  relationType: edge[i].data.relationType
                }
              }]);
              this.cy.getElementById(edge[i].data.id).style('opacity', '1');
              this.cy.getElementById(edge[i].data.id).addClass('label');
              this.cy.getElementById(edge[i].data.id).style("edge-text-rotation", "autorotate");
              // stile per elementi inferiti
              if (edge[i].data.inferred === false) {
                this.cy.getElementById(edge[i].data.id).removeClass('inferred')
                // this.cy.getElementById(edge[i].data.id).removeClass('inferredConcettiInclusi')
                this.cy.getElementById(edge[i].data.id).addClass('grigio');
              } else {
                this.cy.getElementById(edge[i].data.id).addClass('inferred')
              }
              if(this.cy.getElementById(edge[i].data.id).hasClass('percorsoSelected')){
                this.cy.getElementById(edge[i].data.id).removeClass('grigio');
                this.cy.getElementById(edge[i].data.id).addClass('percorsoSelected')
              } 
              if(this.cy.getElementById(edge[i].data.id).hasClass('inferredPercorsoSelected')){
                this.cy.getElementById(edge[i].data.id).removeClass('inferred')
                this.cy.getElementById(edge[i].data.id).addClass('inferredPercorsoSelected')
              } 
            }
          })
          
        }
          var layout = this.cy.elements().filter(':visible').layout({
            name: 'cola',
            // convergenceThreshold: 100, // end layout sooner, may be a bit lower quality
            animate: false,
            edgeLength: 250,
            fit: true
          });
          layout.run();
          var elementiVisibili = this.cy.elements(':visible');
          this.cy.center(elementiVisibili);
          // let singoliPercorsi = [];
          for (var i = 0; i < this.arrayConcetti.length; i++) {
            for (var j = 0; j < this.arrayConcetti[0].edges.length; j++) {
              this.singoliPercorsi.push(this.arrayConcetti[i].edges);
            }
          }
        });
      }
      else {
        if(this.arrayConcetti.length === this.arrayNoSenseRel.length){
          this.arrayNoSenseRel.forEach(ele =>{
            ele.edges.forEach(edge=>{
              this.cy.getElementById(edge.data.id).removeClass('inferred')
            })
          })
        } else {
          // elimino elementi in array concetti
        this.arrayConcetti.forEach(ele => {
          ele.nodes.forEach(nodi => {
            let eleConcettiSIDaRimuovere = this.cy.getElementById(nodi.data.id);
            eleConcettiSIDaRimuovere.style('opacity', '0')
          })
          ele.edges.forEach(edge => {
            let eleConcettiSIDaRimuovere = this.cy.getElementById(edge.data.id);
            eleConcettiSIDaRimuovere.style('opacity', '0')
          })
        })

        this.arrayInferiti.forEach(ele => {
          ele.nodes.forEach(nodi => {
            let eledaRipristinare = this.cy.getElementById(nodi.data.id);
            eledaRipristinare.style('opacity', '1')
          })
          ele.edges.forEach(edge => {
            let eledaRipristinare = this.cy.getElementById(edge.data.id);
            eledaRipristinare.style('opacity', '1')
            eledaRipristinare.style('curve-style', 'straight')
          })
        })
        }
        
      }

    });
    // evento tap solo su edge grigio e inferiti
    // panel box dettagli edge si apre SOLO su archi con classe percorsoSelected e percorsoSelectedInferred
    this.cy.on('tap','edge.grigio,edge.inferred', (event) => {
      console.log('tap event')
      this.cy.getElementById(sessionStorage.getItem('edgeClicc')).removeClass('inferredPercorsoSelected');
      this.cy.getElementById(sessionStorage.getItem('edgeClicc')).removeClass('percorsoSelected'); 
      if(sessionStorage.getItem('edgeCliccInferred')==='true'){
        this.cy.getElementById(sessionStorage.getItem('edgeClicc')).addClass('inferred')
      } else {
        this.cy.getElementById(sessionStorage.getItem('edgeClicc')).addClass('grigio')
      }
      sessionStorage.setItem('edgeClicc', event.target.data().id)
      sessionStorage.setItem('edgeCliccInferred', event.target.data().inferred)
     for (var i = 0; i < this.cy.edges().filter(':unselected').length; i++) {
        let edgeNoActive = this.cy.edges().filter(':unselected')
        // this.cy.getElementById(edgeNoActive[i].data().id).removeClass('inferredPercorsoSelected');
        // this.cy.getElementById(edgeNoActive[i].data().id).removeClass('percorsoSelected');
        if (edgeNoActive[i].data().inferred === true) {
          this.cy.getElementById(edgeNoActive[i].data().id).removeClass('inferredPercorsoSelected');
          this.cy.getElementById(edgeNoActive[i].data().id).addClass('inferred');
        } else {
          this.cy.getElementById(edgeNoActive[i].data().id).removeClass('inferred');
          this.cy.getElementById(edgeNoActive[i].data().id).removeClass('percorsoSelected');
          this.cy.getElementById(edgeNoActive[i].data().id).addClass('grigio')
        }
      }
      this.singoliPercorsi.forEach(percorso => {
        percorso.forEach(subPath => {

          if (subPath.data.id === event.target.data().id) {
            for (var i = 0; i < percorso.length; i++) {
              // this.cy.getElementById(percorso[i].data.id).removeClass('grigio')
              this.cy.getElementById(percorso[i].data.id).removeClass('inferred');

              if (percorso[i].data.inferred === true) {
                this.cy.getElementById(percorso[i].data.id).addClass('inferredPercorsoSelected');
              } else {
                this.cy.getElementById(percorso[i].data.id).addClass('percorsoSelected');
              }
            }
          }
        })
      })
    })

    this.fetchSenses();
    this.cercaSensi.get('cercaSensi').valueChanges.pipe(
      debounceTime(500)
      , distinctUntilChanged()
    ).subscribe((text: string) => {
      this.dataStorageService.fetchLexicalSense(text.toLowerCase(), this.searchMode, this.type,
        this.field, this.pos, this.formType, this.author, this.lang, this.status, this.offset, this.limit).pipe(take(1)).subscribe(lexicalEntry => {
          this.sensi = lexicalEntry.list.filter(t =>
            t.senseInstanceName !== '' && t.definition !== ''
          );
          this.sensiVisibili = lexicalEntry.list;
        });
    });
  }

  ngAfterViewInit() {
    // virtual scroll
    this.scroller
      .elementScrolled().pipe(
        map(() => this.scroller.measureScrollOffset('bottom')),
        pairwise(),
        filter(([y1, y2]) => (y2 < y1) && (y2 < 140)),
        throttleTime(200)
      ).subscribe(() => {
        this.ngZone.run(() => {
          this.fetchSenses();
        });
      });
  }

  cliccatoMultiple(senso) {
    sessionStorage.setItem('viewMultipla', senso);
    this.sub = this.dataStorageService.fetchInfoNode(sessionStorage.getItem('viewMultipla')).subscribe(subGraph => {
      this.cy.add([{
        group: "nodes",
        data: {
          id: subGraph.id,
          label: subGraph.label
        }
      }]);
      this.cy.getElementById(sessionStorage.getItem('viewMultipla')).style('display', 'element');
      this.cy.getElementById(sessionStorage.getItem('viewMultipla')).addClass('label');
      this.cy.getElementById(sessionStorage.getItem('viewMultipla')).addClass('grigio');
      let senso1 = this.cy.getElementById(sessionStorage.getItem('senso1'))
      let senso2 = this.cy.getElementById(sessionStorage.getItem('senso2'))
      this.cy.$(senso1).position({
        x: 200,
        y: 200
      });
      this.cy.$(senso2).position({
        x: 800,
        y: 200
      });
      var elementiVisibili = this.cy.elements(':visible');
      this.cy.center(elementiVisibili);
      this.cy.zoom(1)
      this.emettoView.emit(senso);
    });
  }

  nascondiNodiSensiUnchecked(senso) {
    var elem = this.cy.getElementById(senso);
    this.cy.remove(elem);
    // rimuovo nodi collegati a source e target caricati con il servizio min node path salvati nell'array nodi extra
    this.nodiExtra.map(el => {
      var nodoExtra = this.cy.getElementById(el)
      this.cy.remove(nodoExtra)
    });
    var elementiVisibili = this.cy.elements(':visible');
    elem.removeClass('sourceMinPath');
    elem.removeClass('targetMinPath');
    this.cy.center(elementiVisibili);
  }

  fetchSenses() {
    this.sub = this.dataStorageService.fetchLexicalSense(this.searchText, this.searchMode, this.type,
      this.field, this.pos, this.formType, this.author, this.lang, this.status, this.offset, this.limit).pipe(take(1)).subscribe(lexicalEntry => {
        this.sensi = lexicalEntry.list.filter(t =>
          t.senseInstanceName !== '' && t.definition !== ''
        );
        this.limit += 99;
        this.totalCount = lexicalEntry.totalHits;
        this.sensi = this.sensi.concat(this.sensi);
      });
  }

  onChange(e: MatCheckboxChange) {
    if (e.source.checked === true) {
      this.nodiSelezionati.push(e.source.value);
      for (var i = 0; i < this.nodiSelezionati.length; i++) {
        sessionStorage.setItem('senso1', this.nodiSelezionati[0])
        sessionStorage.setItem('senso2', this.nodiSelezionati[1])
      }
      this.cliccatoMultiple(e.source.value);
    } else {
      this.nascondiNodiSensiUnchecked(e.source.value);
      this.nodiSelezionati = this.nodiSelezionati.filter(el => el !== e.source.value)
    }
    sessionStorage.setItem('nodiSelezionati', JSON.stringify(this.nodiSelezionati))
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
